import { useRef } from "react";
import { Drawer, DrawerContent } from "../../../drawer";
import { Button } from "../../../button";
import { typographyVariants } from "../../../typography";
import { CollectFormNodeSchema } from "@aichat/flow-config";
import DynamicForm from "./dynamic-form";
import MessageContainer, { MessageContainerProps } from "../message-container";
import MarkdownRenderer from "../../../markdown-renderer";
import { MessageEmit } from "@aichat/types/index";
import { useSimplePopup } from "@aichat/ui/hooks/use-simple-popup";
import { DialogTitle } from "@radix-ui/react-dialog";
import { toast } from "sonner";
import { Z_INDEX } from "@aichat/constants/widget";

type CollectFormNodeComponentProps = Omit<MessageContainerProps, "children"> & {
  config: CollectFormNodeSchema; // eslint-disable-next-line no-unused-vars
  handleSendForm?: (data: MessageEmit["message"]["form_response"]) => void;
  widgetConfig: MessageContainerProps["widgetConfig"];
};

function CollectFormNodeComponent(props: CollectFormNodeComponentProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const formDrawer = useSimplePopup(false);
  const brandColorHSLA = `hsla(${props.widgetConfig.brandColor.h}, ${props.widgetConfig.brandColor.s}%, ${props.widgetConfig.brandColor.l}%, ${props.widgetConfig.brandColor.a ?? 1})`;

  return (
    <div style={{ zIndex: Z_INDEX.dynamicForm }}>
      <div className="relative" ref={containerRef} />
      <Drawer
        open={formDrawer.isOpen}
        onOpenChange={formDrawer.toggle}
        container={containerRef.current}
      >
        <div onClick={formDrawer.open}>
          <MessageContainer {...props} hideTime>
            <div className="flex flex-col gap-5">
              <MarkdownRenderer
                text={props.config.message}
                widgetConfig={props.widgetConfig}
                type={props.type}
                role={props.role}
              />
              <Button
                style={{
                  background: brandColorHSLA,
                  color:
                    props.widgetConfig.textColor === "dark" ? "black" : "white",
                }}
                className="w-fit"
              >
                {props.config.openButtonText}
              </Button>
            </div>
          </MessageContainer>
        </div>
        <DrawerContent className="h-[80%] mx-2 mb-2 rounded-bl-xl rounded-br-xl">
          <div className="flex flex-col gap-4 p-6">
            <DialogTitle
              className={typographyVariants({ variant: "pSemibold" })}
            >
              {props.config.title}
            </DialogTitle>
            <DynamicForm
              textColor={props.widgetConfig.textColor}
              brandColor={props.widgetConfig.brandColor}
              scrollHeight="h-[360px]"
              handleSendForm={(data) => {
                props.handleSendForm?.(data);
              }}
              onSuccess={() => {
                toast.success("Your response has been submitted.", {
                  position: "top-center",
                });
                formDrawer.close();
              }}
              submitButtonText={props.config.submitButtonText}
              fields={props.config.fields}
              type={props.type}
            />
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  );
}

export default CollectFormNodeComponent;
